import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const categoryRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setCategoryOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (categoryRef.current && !categoryRef.current.contains(e.target as Node)) {
        setCategoryOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-2xl font-bold ${scrolled ? 'text-primary-500' : 'text-primary-500'}`}>
              91吃瓜网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              首页
            </Link>

            <div ref={categoryRef} className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
              >
                分类吃瓜
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </span>
              </button>

              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 rounded-lg border border-background-200/70 py-2 z-50">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      <span className="whitespace-nowrap">{cat.name}</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/category/zuixin-baoliao"
              className="px-4 py-2 text-sm font-medium text-primary-500 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap flex items-center gap-1.5"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-flashlight-line"></i>
              </span>
              最新爆料
            </Link>

            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden p-2 text-foreground-700 hover:text-primary-500 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </span>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors">
              首页
            </Link>
            <div className="px-3 py-2.5 text-sm font-medium text-foreground-500">分类吃瓜</div>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-6 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link to="/category/zuixin-baoliao" className="block px-3 py-2.5 text-sm font-medium text-primary-500 bg-primary-50 rounded-lg mx-1">
              <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                <i className="ri-flashlight-line"></i>
              </span>
              最新爆料
            </Link>
            <Link to="/about" className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}